
<div class="user-selection">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row pb-2 step-description-block">
    <div class="col text-left">Select users for this project:</div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [pageName]="&quot;UserSelection&quot;" [showLimit]="false" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="users.length" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th></th>
            <th>Name</th>
            <th>Email</th>
            <th>Roles</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of displayedUsers, let i = index">
            <td>
              <div class="form-check">
                <input class="form-check-input" id="checkSelectUser{{i}}" type="checkbox" name="user-selection-checkbox-{{user.id}}" [(ngModel)]="user.selected" [disabled]="user.disabled || disableAll" (change)="updateDirty()">
              </div>
            </td>
            <td>{{user.firstName}} {{user.lastName}}</td>
            <td>{{user.emailAddress}}</td>
            <td>{{user.roles}}<span class="oi oi-warning pr-1" *ngIf="showFedLlcStatus &amp;&amp; !user.fedLlcPrivilege" style="color: #ffc107; font-size: 16px; margin-left: 8px;" ngbTooltip="User is not Fed LLC Authorized in TMC and will not have visibility of the project unless Authorized." placement="bottom" container="body"></span></td>
          </tr>
          <tr *ngIf="users.length === 0">
            <td colspan="4">
              <p class="text-center empty-table-message">There are no users to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row pb-2 step-description-block">
    <div class="col text-left">Selected Users:</div>
  </div>
  <div class="row">
    <div class="col-12 table-card pr-4">
      <div class="row">
        <div class="col-12" style="max-height: 250px; overflow-y: auto;">
          <table class="table table-responsive table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Roles</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of selectedUsers">
                <td>{{ user?.displayName }}</td>
                <td>{{ user?.emailAddress }}</td>
                <td style="position: relative;">{{ user?.roles }}<span class="oi oi-warning pr-1" *ngIf="showFedLlcStatus &amp;&amp; !user.fedLlcPrivilege" style="color: #ffc107; font-size: 16px; margin-left: 8px;" ngbTooltip="User is not Fed LLC Authorized in TMC and will not have visibility of the project unless Authorized." placement="bottom" container="body"></span><br></td>
              </tr>
              <tr *ngIf="users.length === 0">
                <td colspan="5">
                  <p class="text-center empty-table-message">There are no selected users</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>